import FallbackLoader from './FallbackLoader';

export default FallbackLoader(() => import(/* webpackChunkName: "async-GenericLeadV13" */'shared-components/components/GenericLeadV13'));
